var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.getters.getLogotitle!=-1)?_c('pagetitle'):_vm._e(),_c('logotitle'),_c('router-view'),_c('footerbox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }